import * as angular from 'angular';
import * as _ from 'lodash';

import { Logger } from '@mode/shared/contract-common';
import template from './space-membership.html';

export default class SpaceMembershipController {
  static $inject = ['$scope', '$log', 'SearchClientService', 'SpaceMembershipModel', 'ToastService'];

  public space: any;
  public owner: any;
  public account: any;
  private users: any;
  private memberships: any[];
  private membershipsCollection: any;
  private query: string;

  constructor(
    public $scope,
    public $log: Logger,
    public searchClientService,
    public SpaceMembershipModel,
    public AlertService
  ) {}

  $onInit() {
    this.getMemberships()
      .then(this.watchMemberships.bind(this))
      .then(this.buildMemberships.bind(this))
      .then(this.clearSearch.bind(this))
      .catch((e) => {
        // TODO: handle error
      });
  }

  getMemberships() {
    return this.space.spaceMemberships({ includes: { space_memberships: 'member' } });
  }

  getMembershipModel() {
    return this.SpaceMembershipModel;
  }

  watchMemberships(membershipsCollection) {
    this.membershipsCollection = membershipsCollection;
    membershipsCollection.watch(this.$scope, this.buildMemberships.bind(this));
    return membershipsCollection.elements();
  }

  buildMemberships(memberships) {
    return this.getMembershipModel()
      .buildMembershipsWithAccount(memberships)
      .then(this.resetMembershipsInSearch.bind(this))
      .then((memberships) => {
        this.memberships = memberships;
      });
  }

  includeMemberships(user) {
    user.membership = null;
    this.memberships.forEach((membership) => {
      if (membership.email === user.email || membership.member_token === user.token) {
        user.membership = membership;
        membership.inSearch = true;
      }
    });
    return user;
  }

  resetMembershipsInSearch(memberships) {
    if (memberships && memberships.length) {
      memberships.forEach((membership) => {
        // only set isSearch to false if its not in the user search list
        if (
          this.users &&
          _.find(this.users, (user: any) => user.email === membership.email || user.token === membership.member_token)
        ) {
          membership.inSearch = true;
        } else {
          membership.inSearch = false;
        }
      });
    }
    return memberships;
  }

  isCurrentUser(account) {
    return function (user): Number {
      return user.email === account.email || user.token === account.token ? -1 : 0;
    };
  }

  orderByCurrentUser(account) {
    return function (user) {
      return user.email === account.email || user.token === account.token ? -1 : 0;
    };
  }

  orderByGroup() {
    return function (user) {
      return user.objectType === 'user_group' ? -1 : 0;
    };
  }

  queryUsers() {
    if (!this.query) {
      this.clearSearch();
      return;
    }

    this.executeSearch(this.query);
  }

  clearSearch() {
    this.users = [];
    this.executeSearch('');
  }

  getSearchOptions() {
    return {
      indexes: ['userEmail', 'group'],
      perPage: 20,
      filters: {
        userEmail: `organization_${this.owner.token},organization_${this.owner.token}_active`,
        group: `organization_${this.owner.token}`,
      },
    };
  }

  executeSearch(query) {
    const opts = _.assign({ query: query }, this.getSearchOptions());

    this.searchClientService
      .query(opts)
      .then(this.handleSearchSuccess.bind(this))
      .catch(this.handleSearchError.bind(this));
  }

  getMembersFromResponse(response) {
    if (this.space.openSpace) {
      // allow all groups including "everyone"
      return [...response.userEmail, ...response.group];
    } else {
      // filter "everyone" group
      const groups = response.group.filter((group) => group.groupType === 'custom');
      return [...response.userEmail, ...groups];
    }
  }

  handleSearchSuccess(response) {
    const searchMembers = this.getMembersFromResponse(response);
    this.resetMembershipsInSearch(this.memberships);
    this.users = this.memberships ? searchMembers.map(this.includeMemberships.bind(this)) : searchMembers;
  }

  handleSearchError() {
    // TODO: handle error
  }

  createMembership(member) {
    return this.SpaceMembershipModel.create({
      space: this.space.token,
      params: {
        'membership.member_token': member.token,
        'membership.member_type': member.objectType === 'user_group' ? 'UserGroup' : 'User',
        includes: ['member'],
      },
    });
  }

  insertMembershipModel(model) {
    this.SpaceMembershipModel.putLocal(model);
  }

  toggleMembership(membership, user) {
    if (membership) {
      const removedType = membership.member_type === 'account' ? 'user' : 'group';
      membership
        .destroy()
        .then(() => {
          this.AlertService.success(`Removed ${removedType}`);
          if (user) {
            user.membership = null;
          }
        })
        .catch((e) => {
          this.AlertService.error(`Could not remove ${removedType}`);
        });
    } else {
      const addedType = user.objectType === 'user_group' ? 'group' : 'user';
      this.createMembership(user)
        .then((newMembership) => {
          this.AlertService.success(`Added ${addedType}`);
          if (user) {
            user.membership = newMembership;
          }
          this.membershipsCollection.insert(newMembership).then(this.insertMembershipModel.bind(this));
        })
        .catch((e) => {
          this.$log.log('error adding user/group', e);
          this.AlertService.error(`Error adding ${addedType}`);
        });
    }
  }
}

const SpaceMembershipComponent: angular.IComponentOptions = {
  bindings: {
    space: '<',
    owner: '<',
    account: '<',
  },
  template: template,
  controller: SpaceMembershipController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('spaceMembership', SpaceMembershipComponent);
